const getCodeStatus = (searchParams: string) => {
  const params = new URLSearchParams(searchParams);
  return params.get('status');
};

export default getCodeStatus;
